import {
  Autocomplete,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SecondaryButton from "../../../../newComponent/NewButtonComp/SubmitButton";
import ResetFilterButton from "../../../../newComponent/NewButtonComp/ResetFilterButton";
import ClearButtonComp from "../../../../newComponent/NewButtonComp/ResetButtonComp";
import CustomSnackbar from "../../../../components/ui-component/snackbar/CustomSnackbar";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function TransferStudent({ selectedData }) {
  const userId = localStorage.getItem("userId");
  const [alltrainers, setAllTrainers] = useState([]);
  const [trainerName, setTrainerName] = useState(null);
  const [classList, setClassList] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleTrainerNameChange = (event, value) => {
    setTrainerName(value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/gettrainers/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );

          setAllTrainers(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [userId]);

  const handleFetchClasses = async () => {
    const requestData = {
      trainer_id: trainerName?.id,
      test_type_id: selectedData?.test_type_id?.id,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}route/classbytrainer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok) {
        setClassList(data);
      } else {
        console.log(data?.message, "error");
        setClassList([]);
      }
    } catch (error) {
      console.error("Network or Server Error:", error);

      setClassList([]);
    }
  };

  useEffect(() => {
    if (trainerName) {
      handleFetchClasses();
    }
  }, [trainerName?.id, selectedData?.test_type_id?.id]);

  const handleChangeClass = (event, value) => {
    setSelectedClass(value);
  };

  const handleTransferStudent = async () => {
    if (!trainerName) {
      showSnackbar("Please select trainer", "error");
      return;
    }

    if (!selectedClass) {
      showSnackbar("Please select class", "error");
      return;
    }

    const requestData = {
      prev_class_id: selectedData?.id,
      new_class_id: parseInt(selectedClass?.id),
      user_id: parseInt(userId),
    };

    try {
      const response = await fetch(`${API_ENDPOINT}class/transfer-student`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok) {
        showSnackbar("Student Transffred Successfully");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        showSnackbar(data?.message, "error");
      }
    } catch (error) {
      console.error("Network or Server Error:", error);
      showSnackbar("Server error", "error");
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5">
            Total Active Student :{" "}
            <span style={{ fontWeight: 700 }}>
              {" "}
              {selectedData?.enrolled_student}
            </span>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">
            Select Trainer{" "}
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Autocomplete
            size="small"
            value={trainerName}
            onChange={handleTrainerNameChange}
            options={alltrainers}
            getOptionLabel={(option) =>
              `${option.first_name ? option.first_name : ""} ${
                option.last_name ? option.last_name : ""
              }`
            }
            renderInput={(params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  style: { borderRadius: "10px" }, // Add borderRadius here
                }}
              />
            )}
          />
        </Grid>
        {trainerName && (
          <Grid item xs={12}>
            <Typography variant="h6">
              Select Class{" "}
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <Autocomplete
              size="small"
              value={selectedClass}
              noOptionsText={
                trainerName && classList.length === 0
                  ? " No Class match with selected criteria.Please select another trainer."
                  : ""
              }
              onChange={handleChangeClass}
              options={classList}
              getOptionLabel={(option) => option?.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    style: { borderRadius: "10px" }, // Add borderRadius here
                  }}
                />
              )}
            />
          </Grid>
        )}
        <Grid item xs={12} container gap={2} justifyContent="flex-end">
          {/* <ClearButtonComp label="Cancel" showIcon={false}/> */}
          <SecondaryButton
            label="Transfer Student"
            onClick={handleTransferStudent}
          />
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
